(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var dataEl = document.querySelector('[data-product-json]');
  var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
  var variants = data.variants || [];
  var form = document.getElementById('tpo-product-form');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
  var mainImg = root.querySelector('[data-main-image]');
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('es-CO', { style: 'currency', currency: data.currency || 'COP', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100); }
  };
  var $ = function (sel) { return root.querySelector(sel); };
  function setImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-pressed', String(t.getAttribute('data-src').split('?')[0] === src.split('?')[0]));
    });
  }
  function selected() {
    return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
  }
  function findVariant(opts) {
    return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
  }
  function markAvailability(opts) {
    groups.forEach(function (g, gi) {
      g.querySelectorAll('input').forEach(function (inp) {
        var test = opts.slice(); test[gi] = inp.value;
        var v = findVariant(test);
        inp.closest('.tpo-val').classList.toggle('tpo-val--off', !(v && v.available));
      });
    });
  }
  function update(fromUser) {
    var opts = selected();
    groups.forEach(function (g, i) { var s = g.querySelector('[data-selected]'); if (s) s.textContent = opts[i] || ''; });
    var v = findVariant(opts);
    markAvailability(opts);
    var ok = !!(v && v.available);
    var atc = form && form.querySelector('[data-atc]');
    if (atc) atc.disabled = !ok;
    var st = document.querySelector('[data-status]');
    if (st) st.textContent = v ? (ok ? '' : 'Esta combinación está agotada. Elige otra talla o color.') : 'Esta combinación no existe.';
    if (!v) return;
    var idInput = form.querySelector('[data-variant-id]');
    idInput.value = v.id;
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    $('[data-price]').textContent = fmt(v.price);
    var cmp = $('[data-compare]'), save = $('[data-save]'), badge = $('[data-badge]');
    var has = v.compare_at_price && v.compare_at_price > v.price;
    if (cmp) { cmp.hidden = !has; if (has) cmp.textContent = fmt(v.compare_at_price); }
    if (save) { save.hidden = !has; if (has) save.textContent = '¡Ahorras ' + fmt(v.compare_at_price - v.price) + '!'; }
    if (badge && has) badge.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
    var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = fmt(v.price);
    if (fromUser && v.featured_image) setImage(v.featured_image.src);
    if (fromUser && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
  }
  groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
  root.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () { setImage(t.getAttribute('data-src')); });
  });
  var sizeBtn = root.querySelector('[data-size-guide]');
  var guide = null;
  root.querySelectorAll('.tpo-desc h2, .tpo-desc h3, .tpo-desc h4, .tpo-desc p, .tpo-desc div, .tpo-desc strong, .tpo-desc b').forEach(function (el) {
    if (!guide && el.children.length < 3 && /gu[ií]a de tallas/i.test(el.textContent)) guide = el;
  });
  if (sizeBtn) {
    if (!guide) sizeBtn.hidden = true;
    else sizeBtn.addEventListener('click', function () { guide.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }
  function addDays(n) { var d = new Date(), k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) k++; } return d; }
  var months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  var f = function (d) { return d.getDate() + ' ' + months[d.getMonth()]; };
  var e0 = root.querySelector('[data-eta-0]'), e1 = root.querySelector('[data-eta-1]'), e2 = root.querySelector('[data-eta-2]');
  if (e0) e0.textContent = 'Hoy';
  if (e1) e1.textContent = f(addDays(1));
  if (e2) e2.textContent = f(addDays(2)) + ' - ' + f(addDays(5));
  function codButton() {
    return document.querySelector('#rsi_buy_now_button, ._rsi-buy-now-button, [class*="rsi-buy-now-button"] button, [class*="rsi-buy-now-button"]');
  }
  var sticky = document.querySelector('[data-sticky]');
  var stickyBtn = document.querySelector('[data-sticky-buy]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var b = codButton();
      if (b) { b.click(); return; }
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
    }).observe(form);
  }
  update(false);
})();
